export default {
    methods: {
        srvTime() {
            let xmlHttp: any;
            try {
                //FF, Opera, Safari, Chrome
                xmlHttp = new XMLHttpRequest();
            } catch (err1) {
                //IE
                try {
                xmlHttp = new ActiveXObject('Msxml2.XMLHTTP');
                } catch (err2) {
                try {
                    xmlHttp = new ActiveXObject('Microsoft.XMLHTTP');
                } catch (eerr3) {
                    alert("AJAX not supported");
                }
                }
            }
            xmlHttp.open('HEAD', window.location.href.toString(), false);
            xmlHttp.setRequestHeader("Content-Type", "text/html");
            xmlHttp.send('');
            let st = xmlHttp.getResponseHeader("Date");
            let d = new Date(st);
            return isNaN(d.getTime()) ? false : d;
        },
    },
};